module.exports = __webpack_public_path__ + "static/media/Insurance.eb13aa7e.svg";